import styled from '@emotion/styled';
import { Box, css } from 'theme-ui';

const FormWrapper = styled(Box)(
  css({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: ['65px 25px 95px', '75px 30px 105px', '85px 40px 125px 40px'],
    background: 'linear-gradient(115.51deg, #191e1d 13.83%, #123239 53.2%)',
    color: 'white',
  }),
);

export default FormWrapper;
